import { render, staticRenderFns } from "./visitas.vue?vue&type=template&id=d8ce6ff4"
import script from "./visitas.vue?vue&type=script&lang=js"
export * from "./visitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports